import { useEffect, useState } from "react";

import {
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import {
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";

import { db } from "../firebase/firebase";

export default function CourseView() {

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const id = searchParams.get("id");

  const [loading, setLoading] = useState(true);

  const [saving, setSaving] = useState(false);

  const [activeTab, setActiveTab] =
    useState("overview");

  // const [course, setCourse] = useState({
  //   id: "",
  //   title: "",
  //   slug: "",
  //   shortDescription: "",
  //   category: "",
  //   duration: "",
  //   isPopular: false,

  //   seo: {
  //     seoTitle: "",
  //     seoDescription: "",
  //     seoKeywords: [],
  //   },

  //   media: {
  //     banner: "",
  //     thumbnail: "",
  //     logo: "",
  //     img: "",
  //   },

  //   outcomes: [],

  //   faqs: [],

  //   testimonials: [],

  //   projects: {
  //     core: [],
  //     jobReady: [],
  //     pro: [],
  //   },

  //   tiers: [],
  // });


  const [course, setCourse] = useState({
    id: "",
    title: "",
    slug: "",
    shortDescription: "",
    category: "",
    duration: "",
    isPopular: false,

    seo: {
      seoTitle: "",
      seoDescription: "",
      seoKeywords: [],
    },

    media: {
      banner: "",
      thumbnail: "",
      logo: "",
      img: "",
    },

    overview: {
      description: "",
    },

    outcomes: [],

    toolsMastery: [],
    whatYouBuild: [],
    skillsYouGain: [],
    careerOpportunities: [],
    whoShouldJoin: [],

    marketRelevance: {
      title: "",
      points: [],
    },

    gallery: [],

    certificate: {
      title: "",
      preview: "",
    },

    stats: {
      studentsTrained: "",
      projectsCompleted: "",
      successRate: "",
      placementSupport: "",
    },

    relatedCourses: [],

    faqs: [],
    testimonials: [],

    projects: {
      core: [],
      jobReady: [],
      pro: [],
    },

    tiers: [],
  });



  /* ---------------- FETCH ---------------- */
  useEffect(() => {

    fetchCourse();

  }, []);

  const fetchCourse = async () => {

    try {

      const snap = await getDoc(
        doc(db, "course", "allCourses")
      );

      if (snap.exists()) {

        const allCourses =
          snap.data().courses || [];

        const foundCourse =
          allCourses.find(
            (item) => item.id === id
          );

        if (foundCourse) {

          setCourse(foundCourse);

        } else {

          alert("Course not found");
        }
      }

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);
    }
  };

  /* ---------------- SAVE ---------------- */
  const handleSave = async () => {

    try {

      setSaving(true);

      const courseRef = doc(
        db,
        "course",
        "allCourses"
      );

      const snap = await getDoc(
        courseRef
      );

      if (!snap.exists()) {
        return alert(
          "Course document missing"
        );
      }

      const allCourses =
        snap.data().courses || [];

      const updatedCourses =
        allCourses.map((item) => {

          if (item.id === id) {
            return course;
          }

          return item;
        });

      await setDoc(courseRef, {
        courses: updatedCourses,
      });

      alert("Course Updated ✅");

    } catch (err) {

      console.error(err);

      alert("Failed ❌");

    } finally {

      setSaving(false);
    }
  };

  /* ---------------- BASIC ---------------- */
  const handleChange = (e) => {

    const {
      name,
      value,
      type,
      checked,
    } = e.target;

    setCourse((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));
  };

  /* ---------------- SEO ---------------- */
  const handleSeoChange = (
    key,
    value
  ) => {

    setCourse((prev) => ({
      ...prev,
      seo: {
        ...prev.seo,
        [key]: value,
      },
    }));
  };

  /* ---------------- MEDIA ---------------- */
  const handleMediaChange = (
    key,
    value
  ) => {

    setCourse((prev) => ({
      ...prev,
      media: {
        ...prev.media,
        [key]: value,
      },
    }));
  };

  /* ---------------- ARRAY ---------------- */
  const updateArray = (
    field,
    index,
    value
  ) => {

    const updated = [
      ...(course[field] || []),
    ];

    updated[index] = value;

    setCourse({
      ...course,
      [field]: updated,
    });
  };

  const addArrayItem = (field) => {

    setCourse({
      ...course,
      [field]: [
        ...(course[field] || []),
        "",
      ],
    });
  };

  const removeArrayItem = (
    field,
    index
  ) => {

    const updated =
      course[field].filter(
        (_, i) => i !== index
      );

    setCourse({
      ...course,
      [field]: updated,
    });
  };

  /* ---------------- FAQ ---------------- */
  const updateFaq = (
    index,
    key,
    value
  ) => {

    const updated = [
      ...(course.faqs || []),
    ];

    updated[index][key] = value;

    setCourse({
      ...course,
      faqs: updated,
    });
  };

  /* ---------------- TESTIMONIAL ---------------- */
  const updateTestimonial = (
    index,
    key,
    value
  ) => {

    const updated = [
      ...(course.testimonials || []),
    ];

    updated[index][key] = value;

    setCourse({
      ...course,
      testimonials: updated,
    });
  };

  /* ---------------- PROJECTS ---------------- */
  const updateProject = (
    type,
    index,
    value
  ) => {

    const updated = {
      ...course.projects,
    };

    updated[type][index] = value;

    setCourse({
      ...course,
      projects: updated,
    });
  };

  const addProject = (type) => {

    setCourse({
      ...course,
      projects: {
        ...course.projects,
        [type]: [
          ...(course.projects[type] ||
            []),
          "",
        ],
      },
    });
  };

  const removeProject = (
    type,
    index
  ) => {

    const updated = {
      ...course.projects,
    };

    updated[type] = updated[
      type
    ].filter((_, i) => i !== index);

    setCourse({
      ...course,
      projects: updated,
    });
  };

  /* ---------------- TIER ---------------- */
  const addTier = () => {

    setCourse({
      ...course,
      tiers: [
        ...(course.tiers || []),
        {
          name: "",
          durationMonths: "",
          deliveryMode: "",
          price: {
            original: "",
            offer: "",
          },
          syllabus: [],
        },
      ],
    });
  };

  const updateTier = (
    index,
    key,
    value
  ) => {

    const updated = [
      ...(course.tiers || []),
    ];

    updated[index][key] = value;

    setCourse({
      ...course,
      tiers: updated,
    });
  };

  const updateTierPrice = (
    index,
    key,
    value
  ) => {

    const updated = [
      ...(course.tiers || []),
    ];

    updated[index].price[key] =
      value;

    setCourse({
      ...course,
      tiers: updated,
    });
  };

  const addSyllabus = (
    tierIndex
  ) => {

    const updated = [
      ...(course.tiers || []),
    ];

    updated[tierIndex].syllabus.push(
      {
        module: "",
        title: "",
        topics: [],
      }
    );

    setCourse({
      ...course,
      tiers: updated,
    });
  };

  const updateSyllabus = (
    tierIndex,
    syllabusIndex,
    key,
    value
  ) => {

    const updated = [
      ...(course.tiers || []),
    ];

    updated[tierIndex].syllabus[
      syllabusIndex
    ][key] = value;

    setCourse({
      ...course,
      tiers: updated,
    });
  };

  const addTopic = (
    tierIndex,
    syllabusIndex
  ) => {

    const updated = [
      ...(course.tiers || []),
    ];

    updated[tierIndex].syllabus[
      syllabusIndex
    ].topics.push("");

    setCourse({
      ...course,
      tiers: updated,
    });
  };

  const updateTopic = (
    tierIndex,
    syllabusIndex,
    topicIndex,
    value
  ) => {

    const updated = [
      ...(course.tiers || []),
    ];

    updated[tierIndex].syllabus[
      syllabusIndex
    ].topics[topicIndex] = value;

    setCourse({
      ...course,
      tiers: updated,
    });
  };

  if (loading) {

    return (
      <div className="text-white">
        Loading...
      </div>
    );
  }

  return (

    <div className="text-white pb-40">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-8">

        <div>

          <h1 className="text-3xl font-bold text-orange-500">
            {course.title}
          </h1>

          <p className="text-slate-400">
            Manage Course
          </p>

        </div>

        <button
          onClick={() => navigate(-1)}
          className="bg-white/10 hover:bg-white/20 px-4 py-2 rounded-xl"
        >
          Back
        </button>

      </div>

      {/* TABS */}
      <div className="flex flex-wrap gap-3 mb-8">

        {[
          "overview",
          "seo",
          "media",
          "tools",
          "career",
          "gallery",
          "projects",
          "outcomes",
          "faqs",
          "testimonials",
          "tiers",
        ].map((tab) => (

          <button
            key={tab}
            onClick={() =>
              setActiveTab(tab)
            }
            className={`px-4 py-2 rounded-xl transition-all capitalize ${activeTab === tab
              ? "bg-orange-500"
              : "bg-white/10 hover:bg-white/20"
              }`}
          >
            {tab}
          </button>

        ))}

      </div>

      {/* OVERVIEW */}
      {activeTab === "overview" && (

        <div className="grid md:grid-cols-2 gap-5">

          <Input
            label="Title"
            value={course.title}
            onChange={(e) =>
              setCourse({
                ...course,
                title: e.target.value,
              })
            }
          />

          <Input
            label="Slug"
            value={course.slug}
            onChange={(e) =>
              setCourse({
                ...course,
                slug: e.target.value,
              })
            }
          />

          <Input
            label="Course ID"
            value={course.id}
            onChange={(e) =>
              setCourse({
                ...course,
                id: e.target.value,
              })
            }
          />

          <Input
            label="Category"
            value={course.category}
            onChange={(e) =>
              setCourse({
                ...course,
                category:
                  e.target.value,
              })
            }
          />

          <Input
            label="Duration"
            value={course.duration}
            onChange={(e) =>
              setCourse({
                ...course,
                duration:
                  e.target.value,
              })
            }
          />

          <div className="flex items-center gap-3 mt-8">

            <input
              type="checkbox"
              checked={course.isPopular}
              onChange={(e) =>
                setCourse({
                  ...course,
                  isPopular:
                    e.target.checked,
                })
              }
            />

            <label>
              Popular Course
            </label>

          </div>

          <div className="md:col-span-2">

            <Textarea
              label="Short Description"
              value={
                course.shortDescription
              }
              onChange={(e) =>
                setCourse({
                  ...course,
                  shortDescription:
                    e.target.value,
                })
              }
            />

          </div>


          <Textarea
            label="Overview Description"
            value={course.overview?.description || ""}
            onChange={(e) =>
              setCourse({
                ...course,
                overview: {
                  ...course.overview,
                  description: e.target.value,
                },
              })
            }
          />

          <Input
            label="Certificate Title"
            value={course.certificate?.title || ""}
            onChange={(e) =>
              setCourse({
                ...course,
                certificate: {
                  ...course.certificate,
                  title: e.target.value,
                },
              })
            }
          />

          <Input
            label="Certificate Preview"
            value={course.certificate?.preview || ""}
            onChange={(e) =>
              setCourse({
                ...course,
                certificate: {
                  ...course.certificate,
                  preview: e.target.value,
                },
              })
            }
          />


        </div>

      )}

      {/* SEO */}
      {activeTab === "seo" && (

        <div className="space-y-5">

          <Input
            label="SEO Title"
            value={
              course.seo?.seoTitle ||
              ""
            }
            onChange={(e) =>
              handleSeoChange(
                "seoTitle",
                e.target.value
              )
            }
          />

          <Textarea
            label="SEO Description"
            value={
              course.seo
                ?.seoDescription || ""
            }
            onChange={(e) =>
              handleSeoChange(
                "seoDescription",
                e.target.value
              )
            }
          />

          <ArrayEditor
            title="SEO Keywords"
            items={
              course.seo
                ?.seoKeywords || []
            }
            onAdd={() => {

              handleSeoChange(
                "seoKeywords",
                [
                  ...(course.seo
                    ?.seoKeywords ||
                    []),
                  "",
                ]
              );

            }}
            onChange={(
              index,
              value
            ) => {

              const updated = [
                ...(course.seo
                  ?.seoKeywords ||
                  []),
              ];

              updated[index] = value;

              handleSeoChange(
                "seoKeywords",
                updated
              );

            }}
            onRemove={(index) => {

              const updated =
                course.seo.seoKeywords.filter(
                  (_, i) =>
                    i !== index
                );

              handleSeoChange(
                "seoKeywords",
                updated
              );

            }}
          />

        </div>

      )}

      {/* MEDIA */}
      {activeTab === "media" && (

        <div className="grid md:grid-cols-2 gap-5">

          {[
            "banner",
            "thumbnail",
            "logo",
            "img",
          ].map((field) => (

            <div key={field}>

              <Input
                label={field}
                value={
                  course.media?.[
                  field
                  ] || ""
                }
                onChange={(e) =>
                  handleMediaChange(
                    field,
                    e.target.value
                  )
                }
              />

              {course.media?.[
                field
              ] && (

                  <img
                    src={
                      course.media[
                      field
                      ]
                    }
                    alt=""
                    className="mt-3 rounded-xl border border-white/10 max-h-48 object-cover"
                  />

                )}

            </div>

          ))}

        </div>

      )}

      {activeTab === "tools" && (
        <div className="space-y-10">

          <ArrayEditor
            title="Tools Mastery"
            items={course.toolsMastery || []}
            onAdd={() => addArrayItem("toolsMastery")}
            onChange={(i, v) => updateArray("toolsMastery", i, v)}
            onRemove={(i) => removeArrayItem("toolsMastery", i)}
          />

          <ArrayEditor
            title="What You Build"
            items={course.whatYouBuild || []}
            onAdd={() => addArrayItem("whatYouBuild")}
            onChange={(i, v) => updateArray("whatYouBuild", i, v)}
            onRemove={(i) => removeArrayItem("whatYouBuild", i)}
          />

          <ArrayEditor
            title="Skills You Gain"
            items={course.skillsYouGain || []}
            onAdd={() => addArrayItem("skillsYouGain")}
            onChange={(i, v) => updateArray("skillsYouGain", i, v)}
            onRemove={(i) => removeArrayItem("skillsYouGain", i)}
          />

        </div>
      )}

      {activeTab === "career" && (
        <div className="space-y-10">

          <ArrayEditor
            title="Career Opportunities"
            items={course.careerOpportunities || []}
            onAdd={() => addArrayItem("careerOpportunities")}
            onChange={(i, v) =>
              updateArray("careerOpportunities", i, v)
            }
            onRemove={(i) =>
              removeArrayItem("careerOpportunities", i)
            }
          />

          <ArrayEditor
            title="Who Should Join"
            items={course.whoShouldJoin || []}
            onAdd={() => addArrayItem("whoShouldJoin")}
            onChange={(i, v) =>
              updateArray("whoShouldJoin", i, v)
            }
            onRemove={(i) =>
              removeArrayItem("whoShouldJoin", i)
            }
          />

        </div>
      )}

      {activeTab === "gallery" && (
        <Textarea
          label="Gallery JSON"
          value={JSON.stringify(course.gallery || [], null, 2)}
          onChange={(e) =>
            setCourse({
              ...course,
              gallery: JSON.parse(e.target.value || "[]"),
            })
          }
        />
      )}

      {/* PROJECTS */}
      {activeTab === "projects" && (

        <div className="space-y-10">

          {[
            "core",
            "jobReady",
            "pro",
          ].map((type) => (

            <ArrayEditor
              key={type}
              title={`${type} Projects`}
              items={
                course.projects?.[
                type
                ] || []
              }
              onAdd={() =>
                addProject(type)
              }
              onChange={(
                index,
                value
              ) =>
                updateProject(
                  type,
                  index,
                  value
                )
              }
              onRemove={(index) =>
                removeProject(
                  type,
                  index
                )
              }
            />

          ))}

        </div>

      )}

      {/* OUTCOMES */}
      {activeTab === "outcomes" && (

        <ArrayEditor
          title="Outcomes"
          items={
            course.outcomes || []
          }
          onAdd={() =>
            addArrayItem(
              "outcomes"
            )
          }
          onChange={(
            index,
            value
          ) =>
            updateArray(
              "outcomes",
              index,
              value
            )
          }
          onRemove={(index) =>
            removeArrayItem(
              "outcomes",
              index
            )
          }
        />

      )}

      {/* FAQS */}
      {activeTab === "faqs" && (

        <div className="space-y-5">

          {(course.faqs || []).map(
            (faq, index) => (

              <Card key={index}>

                <Input
                  label="Question"
                  value={
                    faq.question
                  }
                  onChange={(e) =>
                    updateFaq(
                      index,
                      "question",
                      e.target.value
                    )
                  }
                />

                <Textarea
                  label="Answer"
                  value={
                    faq.answer
                  }
                  onChange={(e) =>
                    updateFaq(
                      index,
                      "answer",
                      e.target.value
                    )
                  }
                />

              </Card>

            )
          )}

          <button
            onClick={() => {

              setCourse({
                ...course,
                faqs: [
                  ...(course.faqs ||
                    []),
                  {
                    question: "",
                    answer: "",
                  },
                ],
              });

            }}
            className="bg-orange-500 px-5 py-3 rounded-xl"
          >
            Add FAQ
          </button>

        </div>

      )}

      {/* TESTIMONIALS */}
      {activeTab ===
        "testimonials" && (

          <div className="space-y-5">

            {(course.testimonials ||
              []).map(
                (
                  testimonial,
                  index
                ) => (

                  <Card key={index}>

                    <Input
                      label="Name"
                      value={
                        testimonial.name
                      }
                      onChange={(e) =>
                        updateTestimonial(
                          index,
                          "name",
                          e.target.value
                        )
                      }
                    />

                    <Input
                      label="Role"
                      value={
                        testimonial.role
                      }
                      onChange={(e) =>
                        updateTestimonial(
                          index,
                          "role",
                          e.target.value
                        )
                      }
                    />

                    <Textarea
                      label="Message"
                      value={
                        testimonial.message
                      }
                      onChange={(e) =>
                        updateTestimonial(
                          index,
                          "message",
                          e.target.value
                        )
                      }
                    />

                  </Card>

                )
              )}

            <button
              onClick={() => {

                setCourse({
                  ...course,
                  testimonials: [
                    ...(course.testimonials ||
                      []),
                    {
                      name: "",
                      role: "",
                      message: "",
                    },
                  ],
                });

              }}
              className="bg-orange-500 px-5 py-3 rounded-xl"
            >
              Add Testimonial
            </button>

          </div>

        )}

      {/* TIERS */}
      {activeTab === "tiers" && (

        <div className="space-y-10">

          {(course.tiers || []).map(
            (tier, tierIndex) => (

              <div
                key={tierIndex}
                className="bg-white/5 border border-white/10 p-6 rounded-2xl"
              >

                <h2 className="text-2xl font-bold mb-6 text-orange-400">
                  Tier {tierIndex + 1}
                </h2>

                <div className="grid md:grid-cols-2 gap-5">

                  <Input
                    label="Tier Name"
                    value={tier.name}
                    onChange={(e) =>
                      updateTier(
                        tierIndex,
                        "name",
                        e.target.value
                      )
                    }
                  />

                  <Input
                    label="Delivery Mode"
                    value={
                      tier.deliveryMode
                    }
                    onChange={(e) =>
                      updateTier(
                        tierIndex,
                        "deliveryMode",
                        e.target.value
                      )
                    }
                  />

                  <Input
                    label="Duration Months"
                    value={
                      tier.durationMonths
                    }
                    onChange={(e) =>
                      updateTier(
                        tierIndex,
                        "durationMonths",
                        e.target.value
                      )
                    }
                  />

                  <Input
                    label="Offer Price"
                    value={
                      tier.price?.offer
                    }
                    onChange={(e) =>
                      updateTierPrice(
                        tierIndex,
                        "offer",
                        e.target.value
                      )
                    }
                  />

                  <Input
                    label="Original Price"
                    value={
                      tier.price
                        ?.original
                    }
                    onChange={(e) =>
                      updateTierPrice(
                        tierIndex,
                        "original",
                        e.target.value
                      )
                    }
                  />

                </div>

                {/* SYLLABUS */}
                <div className="mt-10 space-y-5">

                  {(tier.syllabus ||
                    []).map(
                      (
                        syllabus,
                        syllabusIndex
                      ) => (

                        <div
                          key={
                            syllabusIndex
                          }
                          className="bg-black/30 border border-white/10 p-5 rounded-xl"
                        >

                          <div className="grid md:grid-cols-3 gap-4">

                            <Input
                              label="Module"
                              value={
                                syllabus.module
                              }
                              onChange={(
                                e
                              ) =>
                                updateSyllabus(
                                  tierIndex,
                                  syllabusIndex,
                                  "module",
                                  e.target
                                    .value
                                )
                              }
                            />

                            <Input
                              label="Title"
                              value={
                                syllabus.title
                              }
                              onChange={(
                                e
                              ) =>
                                updateSyllabus(
                                  tierIndex,
                                  syllabusIndex,
                                  "title",
                                  e.target
                                    .value
                                )
                              }
                            />

                          </div>

                          {/* TOPICS */}
                          <div className="mt-5 space-y-3">

                            <h3 className="font-semibold text-orange-300">
                              Topics
                            </h3>

                            {(syllabus.topics ||
                              []).map(
                                (
                                  topic,
                                  topicIndex
                                ) => (

                                  <input
                                    key={
                                      topicIndex
                                    }
                                    value={
                                      topic
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      updateTopic(
                                        tierIndex,
                                        syllabusIndex,
                                        topicIndex,
                                        e.target
                                          .value
                                      )
                                    }
                                    className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
                                  />

                                )
                              )}

                            <button
                              onClick={() =>
                                addTopic(
                                  tierIndex,
                                  syllabusIndex
                                )
                              }
                              className="bg-blue-600 px-4 py-2 rounded-lg"
                            >
                              Add Topic
                            </button>

                          </div>

                        </div>

                      )
                    )}

                  <button
                    onClick={() =>
                      addSyllabus(
                        tierIndex
                      )
                    }
                    className="bg-orange-500 px-5 py-3 rounded-xl"
                  >
                    Add Syllabus
                  </button>

                </div>

              </div>

            )
          )}

          <button
            onClick={addTier}
            className="bg-orange-500 px-6 py-3 rounded-xl"
          >
            Add Tier
          </button>

        </div>

      )}

      {/* SAVE */}
      <div className="fixed bottom-5 right-5 z-50">

        <button
          onClick={handleSave}
          disabled={saving}
          className="bg-orange-500 hover:bg-orange-600 px-8 py-4 rounded-2xl shadow-2xl font-semibold"
        >
          {saving
            ? "Saving..."
            : "Save Course"}
        </button>

      </div>

    </div>
  );
}

/* ---------------- COMPONENTS ---------------- */

function Input({
  label,
  ...props
}) {

  return (

    <div>

      <label className="block mb-2 text-sm text-slate-300 capitalize">
        {label}
      </label>

      <input
        {...props}
        className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
      />

    </div>
  );
}

function Textarea({
  label,
  ...props
}) {

  return (

    <div>

      <label className="block mb-2 text-sm text-slate-300 capitalize">
        {label}
      </label>

      <textarea
        {...props}
        rows={5}
        className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
      />

    </div>
  );
}

function ArrayEditor({
  title,
  items,
  onAdd,
  onChange,
  onRemove,
}) {

  return (

    <div className="space-y-4">

      <h2 className="text-2xl font-bold text-orange-400">
        {title}
      </h2>

      {items.map(
        (item, index) => (

          <div
            key={index}
            className="flex gap-3"
          >

            <input
              value={item}
              onChange={(e) =>
                onChange(
                  index,
                  e.target.value
                )
              }
              className="flex-1 p-3 rounded-xl bg-black/40 border border-white/20"
            />

            <button
              onClick={() =>
                onRemove(index)
              }
              className="bg-red-600 px-4 rounded-xl"
            >
              Delete
            </button>

          </div>

        )
      )}

      <button
        onClick={onAdd}
        className="bg-orange-500 px-5 py-3 rounded-xl"
      >
        Add {title}
      </button>

    </div>
  );
}

function Card({ children }) {

  return (

    <div className="bg-white/5 p-5 rounded-2xl border border-white/10 space-y-5">

      {children}

    </div>
  );
}